import { WizardModel } from "@/shared/Wizard/models/WizardModel";
import { AdvancedAnalysisWizardStep } from "./AdvancedAnalysisWizardStep";
import { AdvancedAnalysisWizardSharedModel } from "./AdvancedAnaylsisWizardSharedModel";



export class AdvancedAnalysisWizardModel extends WizardModel<AdvancedAnalysisWizardStep, AdvancedAnalysisWizardSharedModel> {
    
    public name: string = "Advanced Analysis";

    constructor(steps: Array<AdvancedAnalysisWizardStep> = []) {
        super();
        this.steps = steps;
    }
    
}